function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15 8.625H5.25c-.621 0-1.125.504-1.125 1.125v9c0 .621.504 1.125 1.125 1.125H15c.621 0 1.125-.504 1.125-1.125v-9c0-.621-.504-1.125-1.125-1.125zM5.25 7.5A2.25 2.25 0 003 9.75v9A2.25 2.25 0 005.25 21H15a2.25 2.25 0 002.25-2.25v-9A2.25 2.25 0 0015 7.5H5.25z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9 4.125h9.75c.621 0 1.125.504 1.125 1.125v9c0 .621-.504 1.125-1.125 1.125h-1.5V16.5h1.5A2.25 2.25 0 0021 14.25v-9A2.25 2.25 0 0018.75 3H9a2.25 2.25 0 00-2.25 2.25V7.5h1.125V5.25c0-.621.504-1.125 1.125-1.125z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.665 13.898a.562.562 0 010-.796l2.386-2.386a.562.562 0 11.796.795l-2.387 2.387a.562.562 0 01-.795 0z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M10.642 10.313c0-.311.252-.563.563-.563h3a.562.562 0 110 1.125h-3a.562.562 0 01-.563-.563z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M14.204 9.75c.311 0 .563.252.563.563v3a.562.562 0 11-1.125 0v-3c0-.311.252-.563.563-.563zM9.352 14.79c.22.22.22.576 0 .795l-2.386 2.387a.562.562 0 11-.796-.796l2.387-2.386c.22-.22.576-.22.795 0z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M9.375 18.375c0 .31-.252.563-.562.563h-3a.562.562 0 110-1.125h3c.31 0 .562.251.562.562z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M5.813 18.938a.562.562 0 01-.563-.563v-3a.562.562 0 111.125 0v3c0 .31-.252.563-.562.563z"
});

function SvgUtility(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

export default SvgUtility;


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/utility.svg
// module id = 1293
// module chunks = 10